import React from "react"
import { Link } from "gatsby"
import Compromiso from "../../images/joaco-compromiso.svg"
import Valores from "../../images/agus-valores.svg"
import ComillasBlack from "../../images/comillas-black.png"

const OurCommitment = () => {
  return (
    <div className="bg-neutral py-20">
      <div className="container mx-auto px-6">
        {/* Our Compromiso */}
        <div className="flex flex-col md:flex-row lg:w-3/4 mx-auto items-center md:pb-8 lg:mb-20">
          <div className="md:w-2/5">
            <img src={Compromiso} alt="Our Commitment" className="pb-8" />
          </div>
          <div className="md:w-3/5 md:pl-8">
            <h3 className="text-5xl font-normal leading-tight pb-8 relative">
              <span className="text-secondary block font-bold">Our</span>
              Commitment
              <img
                src={ComillasBlack}
                alt="Joaquin Antonino, CFO de Avalith."
                className="hidden absolute md:inline top-0 right-0"
              />
            </h3>
            <p className="pb-8">
              <b>The value</b> for which we continually strive in order to make
              a difference.
            </p>
            <p className="pb-8 text-sm font-medium">
              Joaquin Antonino, CFO de Avalith.
            </p>
            <Link
              to="/our-partners"
              title="Our Partners"
              className="mx-auto lg:mr-5 lg:mx-0 my-8 hover:text-white hover:bg-secondary hover:text-variant btn"
            >
              Our partners
            </Link>
          </div>
        </div>

        <hr className="my-10 md:hidden border-white" />

        {/* Our Valores */}

        <div className="flex flex-col md:flex-row-reverse items-center lg:w-3/4 mx-auto">
          <div className="md:w-2/5">
            <img src={Valores} alt="Nuestro Compromiso" className="pb-8" />
          </div>
          <div className="md:w-3/5 md:pr-8">
            <h3 className="text-5xl font-normal leading-tight pb-8 relative">
              <span className="text-secondary block font-bold">Our</span> values{" "}
              <img
                src={ComillasBlack}
                alt="Agustin Antonino, CEO de Avalith."
                className="hidden absolute md:inline top-0 left-2/4"
              />
            </h3>
            <p className="pb-8">
              <b>Avalith is a dynamic company</b>, with a family atmosphere,
              which is passionate about fostering talent, professionalism and,
              especially, teamwork.
            </p>
            <p className="pb-8 text-sm font-medium">
              Agustin Antonino, CEO de Avalith.
            </p>
            {/* <Link
              to="/about-us/our-family"
              title="Our family"
              className="mx-auto lg:mr-5 lg:mx-0 my-8 hover:text-white hover:bg-secondary hover:text-variant btn"
            >
              Our family
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OurCommitment
